module.exports = __webpack_public_path__ + "static/media/17Cortado.1fccc349.png";